import React from 'react';
import ApprovalForm from "../../../forms/ApprovalForm/ApprovalForm";

const ViewSubContainer = ({initialValues}) => {
  return <ApprovalForm initialValues={initialValues}/>;
};

export default ViewSubContainer;